import { AICallSource } from './AILogsClient';

const CHAT_SOURCES: AICallSource[] = ['chat', 'chat-continuation', 'intent-gate', 'chat-memory-extraction'];
const RECORDING_SOURCES: AICallSource[] = ['recording-transcribe', 'recording-chunk-transcribe', 'recording-summary', 'recording-memory-extraction'];
const MEMORY_PIPELINE_SOURCES: AICallSource[] = ['memory-gardener', 'reflection'];

// Badge color encodes the source family at a glance: chat turns, the recording pipeline, and
// the background memory/insights pipeline; one-off calls (attachments, medication, email, dev
// harnesses) fall back to dark.
export const sourceBadgeColor = (source: AICallSource): string => {
    if (CHAT_SOURCES.includes(source)) {
        return 'primary';
    }
    if (RECORDING_SOURCES.includes(source)) {
        return 'secondary';
    }
    if (MEMORY_PIPELINE_SOURCES.includes(source)) {
        return 'tertiary';
    }
    return 'dark';
};
